import { FilterGroupName, LineTypes, StockOptions } from 'results/constants'
import { FilterSectionId } from './constants'
import type { FilterGroupModel } from './orderFilterSections'

const countGroupItems = (
  filters: FilterGroupModel[],
  groupName: FilterGroupName
): number => {
  const filter = filters.find((entry) => entry.groupName === groupName)
  if (!filter) {
    return 0
  }
  return filter.items.length
}

export const getSectionAppliedFilterCount = (
  sectionId: FilterSectionId,
  filters: FilterGroupModel[],
  manufacturers: string[]
): number => {
  if (sectionId === FilterSectionId.VEHICLE_FITMENT) {
    const linesFilter = filters.find(
      (entry) => entry.groupName === FilterGroupName.LINES
    )
    const linesCount =
      linesFilter?.items.filter((item) => item !== LineTypes.ALL_LINES)
        .length ?? 0
    return linesCount + manufacturers.length
  }

  if (sectionId === FilterSectionId.CATEGORY) {
    return countGroupItems(filters, FilterGroupName.PART_TYPE)
  }

  if (sectionId === FilterSectionId.BRAND) {
    return countGroupItems(filters, FilterGroupName.BRANDS)
  }

  if (sectionId === FilterSectionId.AVAILABILITY) {
    const stockFilter = filters.find(
      (entry) => entry.groupName === FilterGroupName.STOCK
    )
    const stockValue = stockFilter?.items[0]
    if (!stockValue || stockValue === StockOptions.SHOW_ALL) {
      return 0
    }
    return 1
  }

  return 0
}
